"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollToBottom;

var _react = require("react");

var _FunctionContext = _interopRequireDefault(require("../ScrollToBottom/FunctionContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollToBottom() {
  var context = (0, _react.useContext)(_FunctionContext.default);
  return context.scrollToBottom;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTY3JvbGxUb0JvdHRvbS5qcyJdLCJuYW1lcyI6WyJ1c2VTY3JvbGxUb0JvdHRvbSIsImNvbnRleHQiLCJGdW5jdGlvbkNvbnRleHQiLCJzY3JvbGxUb0JvdHRvbSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOzs7O0FBRWUsU0FBU0EsaUJBQVQsR0FBNkI7QUFDMUMsTUFBTUMsT0FBTyxHQUFHLHVCQUFXQyx3QkFBWCxDQUFoQjtBQUVBLFNBQU9ELE9BQU8sQ0FBQ0UsY0FBZjtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IEZ1bmN0aW9uQ29udGV4dCBmcm9tICcuLi9TY3JvbGxUb0JvdHRvbS9GdW5jdGlvbkNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTY3JvbGxUb0JvdHRvbSgpIHtcbiAgY29uc3QgY29udGV4dCA9IHVzZUNvbnRleHQoRnVuY3Rpb25Db250ZXh0KTtcblxuICByZXR1cm4gY29udGV4dC5zY3JvbGxUb0JvdHRvbTtcbn1cbiJdfQ==